var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locked)?_c('UiButton',{staticClass:"button-sm",attrs:{"type":"button","loading":_vm.loading},on:{"click":_vm.handleSubmit}},[_vm._v(" "+_vm._s(_vm.$t('unlock'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }